var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "emailConfig",
          staticStyle: { width: "1020px", margin: "0px auto" },
          attrs: {
            rules: _vm.rules,
            model: _vm.emailConfig,
            "status-icon": "",
            "label-position": "left",
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "邮件任务名称", prop: "name" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入邮件任务名称" },
                model: {
                  value: _vm.emailConfig.name,
                  callback: function($$v) {
                    _vm.$set(_vm.emailConfig, "name", $$v)
                  },
                  expression: "emailConfig.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "邮件标题", prop: "mailTitle" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入发送邮件的标题" },
                model: {
                  value: _vm.emailConfig.mailTitle,
                  callback: function($$v) {
                    _vm.$set(_vm.emailConfig, "mailTitle", $$v)
                  },
                  expression: "emailConfig.mailTitle"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "邮件接收人", prop: "mailTo" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入邮件接收人,多个以逗号,隔开" },
                model: {
                  value: _vm.emailConfig.mailTo,
                  callback: function($$v) {
                    _vm.$set(_vm.emailConfig, "mailTo", $$v)
                  },
                  expression: "emailConfig.mailTo"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "邮件发送时间", prop: "mailTime" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "filter-item",
                  staticStyle: { width: "100%" },
                  attrs: { clearable: "", placeholder: "请选择邮件的发送时间" },
                  model: {
                    value: _vm.emailConfig.mailTime,
                    callback: function($$v) {
                      _vm.$set(_vm.emailConfig, "mailTime", $$v)
                    },
                    expression: "emailConfig.mailTime"
                  }
                },
                _vm._l(_vm.timeOptions, function(time) {
                  return _c("el-option", {
                    key: time,
                    attrs: { label: time, value: time }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "对应咨询项", prop: "consults" } },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.emailConfig.items,
                    "element-loading-text": "正在查询中。。。",
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    "max-height": "500px"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "对应咨询项",
                      prop: "consultId"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleConsultSelect(scope.$index)
                                  }
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    readonly: true,
                                    placeholder: "请选择对应咨询项"
                                  },
                                  model: {
                                    value: scope.row.consultName,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "consultName", $$v)
                                    },
                                    expression: "scope.row.consultName"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "产品分类",
                      prop: "pType",
                      width: "270px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  clearable: "",
                                  multiple: "",
                                  placeholder: "请选择产品类型"
                                },
                                model: {
                                  value: scope.row.pType,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "pType", $$v)
                                  },
                                  expression: "scope.row.pType"
                                }
                              },
                              _vm._l(_vm.typeOptions, function(type) {
                                return _c("el-option", {
                                  key: type.id,
                                  attrs: { label: type.name, value: type.id }
                                })
                              }),
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "首次触发数量",
                      prop: "cntFirst",
                      width: "100px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              attrs: { type: "number", placeholder: "请输入" },
                              model: {
                                value: scope.row.cntFirst,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "cntFirst", $$v)
                                },
                                expression: "scope.row.cntFirst"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "二次触发数量",
                      prop: "cntSecond",
                      width: "100px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              attrs: { type: "number", placeholder: "请输入" },
                              model: {
                                value: scope.row.cntSecond,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "cntSecond", $$v)
                                },
                                expression: "scope.row.cntSecond"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "增量触发数量",
                      prop: "cntIncrement",
                      width: "100px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              attrs: { type: "number", placeholder: "请输入" },
                              model: {
                                value: scope.row.cntIncrement,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "cntIncrement", $$v)
                                },
                                expression: "scope.row.cntIncrement"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-row", [
            _c(
              "div",
              {
                staticStyle: {
                  float: "right",
                  cursor: "pointer",
                  color: "#09afff",
                  display: "block",
                  padding: "5px 0",
                  "font-size": "12px"
                },
                on: { click: _vm.handleAddItem }
              },
              [_c("i", { staticClass: "el-icon-plus" }), _vm._v("添加发送规则")]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["GET /admin/emailConfig/logList"],
                  expression: "['GET /admin/emailConfig/logList']"
                }
              ],
              attrs: { type: "text" },
              on: { click: _vm.handleViewLog }
            },
            [_vm._v("查看发送日志")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["GET /admin/emailConfig/list"],
                  expression: "['GET /admin/emailConfig/list']"
                }
              ],
              attrs: { type: "primary" },
              on: { click: _vm.createData }
            },
            [_vm._v("保存设置")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("selectConsultModel", { ref: "selectConsultModel" }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "邮件发送日志", visible: _vm.dialogViewVisible },
          on: {
            "update:visible": function($event) {
              _vm.dialogViewVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading"
                }
              ],
              attrs: {
                data: _vm.logList,
                "element-loading-text": "正在查询中。。。",
                border: "",
                fit: "",
                "highlight-current-row": ""
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "邮件名称",
                  prop: "configName"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "center", label: "接收邮箱", prop: "mailTo" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "center", label: "发送结果", prop: "result" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.result ? "成功" : "失败") +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "发送时间",
                  prop: "createTime"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0"
              }
            ],
            attrs: {
              total: _vm.total,
              page: _vm.listQuery.page,
              limit: _vm.listQuery.limit
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.listQuery, "page", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.listQuery, "limit", $event)
              },
              pagination: _vm.getList
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }